import type { FC } from 'react'

import { Textarea } from '@skytech/ui'

import { Translation } from '@/app/translations/Translation'

import { useNewSubscriptionContext } from './NewSubscriptionForm.context'

const NewSubscriptionConfirm: FC = () => {
  const [comment, setComment] = useNewSubscriptionContext().comment

  return (
    <>
      <h3>
        <Translation id="Confirm" />
      </h3>

      <Textarea
        id="new-sub-comment"
        label={<Translation id="Comment" />}
        value={comment}
        onChange={e => setComment(e.target.value)}
      />
    </>
  )
}

export default NewSubscriptionConfirm
